import { URL_CONFIG } from "./urlConfig";

export const API_URL = {
  LOGIN: `${URL_CONFIG.API_BASE_URL}/corvell/api/login.php`,
  SAVE_FORM_DATA: `${URL_CONFIG.API_BASE_URL}/corvell/api/form-data.php`,
  SAVE_EXTENDED_WARRANTY: `${URL_CONFIG.API_BASE_URL}/corvell/api/form-warranty.php`,
  GET_DASHBOARD_DATA: `${URL_CONFIG.API_BASE_URL}/corvell/api/tableData.php`,
};
